import { useMemo, useState } from 'react'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  getPeriodoMesAtual,
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../../../services/util/date.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_POSICOES: 'Carregando posições',
  GET_PRODUTOS: 'Carregando produtos',
  ASSOC_POS: 'Associando posições ao inventario',
  ASSOC_POS_AUTO: 'Associando posições automaticamente ao inventario',
}

const INITIAL_STATE = {
  posicoes: [],
  selectedPosicoes: [],
  produtos: [],
  produtosLoaded: false,
  selectedProduto: null,
  associacaoAutomaticaCollapsed: true,
  periodoAssociacaoAutomatica: getPeriodoMesAtual(),
  pathToRedirect: null,
  globalFilter: '',
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  successMessage: null,
}

export default function useAssociarPosicoes() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      getPosicoesToAssoc(selectedTp, estoqueId, inventarioId) {
        EstoqueHttp.getPosicoesEstoqueToAssoc(selectedTp, estoqueId, inventarioId)
          .then(res => {
            setState(prevState => ({
              ...prevState,
              posicoes: res,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      getProdutosFromCompany(companyId) {
        EstoqueHttp.getProdutosAssociacaoAutomaticaInventario(companyId)
          .then(res => {
            const produtos = res.map(produto => ({
              ...produto,
              produto: produto.product_code
                ? `${produto.product_code} - ${produto.name}`
                : produto.name,
            }))
            setState(prevState => ({
              ...prevState,
              produtos,
              produtosLoaded: true,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              produtosLoaded: false,
              errorMessage: errorHandler(err),
            })),
          )
      },

      assocPosicoesToInventario(selectedTp, inventarioId, estoqueId, selectedPosicoes) {
        EstoqueHttp.associarPosicoesToInventario(
          selectedTp,
          inventarioId,
          estoqueId,
          selectedPosicoes.map(p => p.posicao_estoque_id),
        )
          .then(res => {
            const posAssocIds = res.map(pos => pos.posicao_estoque_id)
            setState(prevState => ({
              ...prevState,
              successMessage: 'Posições associadas com sucesso',
              posicoes: prevState.posicoes.filter(p => !posAssocIds.includes(p.posicao_estoque_id)),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      assocPosicoesToInventarioByProductMovement(
        selectedTp,
        inventarioId,
        estoqueId,
        selectedProduto,
        periodo,
      ) {
        EstoqueHttp.associarPosicoesToInventarioByProductMovement(
          selectedTp,
          inventarioId,
          estoqueId,
          selectedProduto.id,
          parseToMysqlFormatWithTime00(periodo.dataInicial),
          parseToMysqlFormatWithTime23(periodo.dataFinal),
        )
          .then(res => {
            const posAssocIds = res.map(pos => pos.posicao_estoque_id)
            setState(prevState => ({
              ...prevState,
              successMessage: 'Posições associadas com sucesso',
              posicoes: prevState.posicoes.filter(p => !posAssocIds.includes(p.posicao_estoque_id)),
              selectedPosicoes: [],
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(err),
            })),
          )
      },

      //Actions

      onInit(selectedTp) {
        if (selectedTp) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.GET_POSICOES,
          }))
        } else {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        }
      },

      onChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          return { ...prevState }
        })
      },

      onClickAssocPos(posicoes) {
        if (!posicoes.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos uma posição para associar',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.ASSOC_POS }))
      },

      onToggleAssociacaoAutomatica(collapsed, companyId) {
        if (!companyId) {
          setState(prevState => ({
            ...prevState,
            associacaoAutomaticaCollapsed: true,
            errorMessage: 'Não foi possível identificar a empresa do inventário',
          }))
          return
        }

        setState(prevState => ({
          ...prevState,
          associacaoAutomaticaCollapsed: collapsed,
          loadingMessage:
            !collapsed && !prevState.produtosLoaded
              ? LOAD_MESSAGE.GET_PRODUTOS
              : prevState.loadingMessage,
        }))
      },

      onPeriodoAssociacaoAutomaticaChange(dataInicial, dataFinal) {
        setState(prevState => ({
          ...prevState,
          periodoAssociacaoAutomatica: { dataInicial, dataFinal },
        }))
      },

      onClickBuscarAssociar(selectedProduto, periodo) {
        if (!selectedProduto || !selectedProduto.id) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione um produto',
          }))
          return
        }

        if (!periodo.dataInicial || !periodo.dataFinal) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Informe o período',
          }))
          return
        }

        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.ASSOC_POS_AUTO }))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
          successMessage: null,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
